import Vue from "vue";
import Router, { RouteConfig } from "vue-router";
import { configureOidc } from "@/store/services/security.service";
import { differenceInMinutes } from "date-fns";
import Logo from "@/views/Logo.vue";
import Logout from "@/views/Logout.vue";
import Home from "@/views/Home.vue";
import Account from "@/views/Account.vue";
import Map from "@/views/Map.vue";
import Mob from "@/views/mob.vue";
import Settings from "@/views/Settings.vue";
import EventLog from "@/views/EventLog.vue";
import Weather from "@/views/Weather.vue";
import SensorLog from "@/views/SensorLog.vue";
import AddContact from "@/views/AddContact.vue";
import EditContact from "@/views/EditContact.vue";
import GeoPermission from "@/views/GeoPermission.vue";
import LogbookRecord from "@/views/LogbookRecord.vue";
import UserImageGallery from "@/views/UserImageGallery.vue";
import accountRoutes from "./accountRoutes";
import { alarm, app } from "@/store/index";
import store from "@/store";
import { config } from "vue/types/umd";

let routerObj = null as Router | null;

export async function configureRouter() {
    if (routerObj) return Promise.resolve(routerObj);

    const idsrvAuth = await configureOidc();
    Vue.use(Router);

    const routes: Array<RouteConfig> = [
        {
            path: "/",
            name: "Logo",
            component: Logo,
            meta: {
                authName: idsrvAuth.authName,
                secure: true,
                showTopBar: false,
            },
        },
        {
            path: "/home",
            name: "Home",
            component: Home,
            meta: {
                authName: idsrvAuth.authName,
                secure: true,
                showTopBar: true,
            },
        },
        {
            path: "/map",
            name: "map",
            component: Map,
            meta: {
                authName: idsrvAuth.authName,
                secure: true,
                showTopBar: false,
            },
        },
        {
            path: "/settings",
            name: "settings",
            component: Settings,
            meta: {
                authName: idsrvAuth.authName,
                secure: true,
                showTopBar: true,
            },
        },
        {
            path: "/profile",
            name: "profile",
            component: Account,
            meta: {
                authName: idsrvAuth.authName,
                secure: true,
                showTopBar: true,
            },
        },
        {
            path: "/authentication/logout-callback",
            name: "callback",
            component: Logout,
            meta: { secure: false, showTopBar: false },
        },
        {
            path: "/mob",
            name: "mob",
            component: Mob,
            meta: {
                authName: idsrvAuth.authName,
                secure: true,
                showTopBar: true,
            },
        },
        {
            path: "/geo-permission",
            name: "geo-permission",
            component: GeoPermission,
            meta: {
                authName: idsrvAuth.authName,
                secure: true,
                showTopBar: true,
            },
        },
        {
            path: "/weather",
            name: "weather",
            component: Weather,
            meta: {
                authName: idsrvAuth.authName,
                secure: true,
                showTopBar: true,
            },
        },
        {
            path: "/event-log",
            name: "event-log",
            component: EventLog,
            meta: {
                authName: idsrvAuth.authName,
                secure: true,
                showTopBar: true,
            },
        },
        {
            path: "/history/:id",
            name: "history",
            component: SensorLog,
            meta: {
                authName: idsrvAuth.authName,
                secure: true,
                showTopBar: true,
            },
        },
        {
            path: "/logbook-record/:daterange",
            name: "LogbookRecord",
            component: LogbookRecord,
            meta: {
                authName: idsrvAuth.authName,
                secure: true,
                showTopBar: false,
            },
        },
        {
            path: "/userGallery/:ids",
            name: "userGallery",
            component: UserImageGallery,
            meta: {
                authName: idsrvAuth.authName,
                secure: true,
                showTopBar: false,
            },
        },
        {
            path: "/addContact",
            name: "addContact",
            component: AddContact,
            meta: {
                authName: idsrvAuth.authName,
                secure: true,
                showTopBar: true,
            },
        },
        {
            path: "/editContact",
            name: "editContact",
            component: EditContact,
            meta: {
                authName: idsrvAuth.authName,
                secure: true,
                showTopBar: true,
            },
        },
        ...accountRoutes,
    ];

    routerObj = new Router({
        mode: "history",
        base: process.env.BASE_URL,
        routes,
    });
    routerObj.beforeEach((to, from, next) => {
        if (to.path.indexOf("authentication") !== -1) {
            next();
        } else {
            if (to.meta.showTopBar !== null) {
                app.showTopBar = to.meta.showTopBar;
            }

            // if going from settings
            if (to.name && from.name && from.name == "settings") {
                console.log("Going from settings");

                if (to.name == "LogbookRecord" || to.name == "addContact" || to.name == "editContact") {

                    console.log("Going to LogbookRecord or addContact or editContact");

                    if (to.name == "LogbookRecord") {
                        console.log("Going to LogbookRecord");
                        app.setMyBoatPanelIndex(1); // Logbook, index myBoat 1
                    } else {
                        console.log("Going to addContact or editContact");
                        app.setMyBoatPanelIndex(2); // Contacts, index myBoat 2
                    }
                    app.setMyBoatPanelOpen(true);
                } else {
                    app.setMyBoatPanelIndex(-1);
                    app.setMyBoatPanelOpen(false);
                }

                if (to.name == "history") {
                    console.log("Going to history with params id: " + to.params.id);

                    if (to.params.id == "4") {
                        app.setSensorsPanelOpen(true);
                        app.setSensorsPanelIndex(0); // Smoke detector, index sensors 0
                    } else if (to.params.id == "5") {
                        app.setSensorsPanelOpen(true);
                        app.setSensorsPanelIndex(1); // CO detector, index sensors 1
                    } else if (to.params.id == "6") {
                        app.setSensorsPanelOpen(true);
                        app.setSensorsPanelIndex(2); // Heat detector, index sensors 2
                    } else if (to.params.id == "7") {
                        app.setSensorsPanelOpen(true);
                        app.setSensorsPanelIndex(4); // Gas detector, index sensors 4
                    } else if (to.params.id == "8") {
                        app.setSensorsPanelOpen(true);
                        app.setSensorsPanelIndex(3); // Water detector, index sensors 3
                    } else if (to.params.id == "17") {
                        app.setSensorsPanelOpen(true);
                        app.setSensorsPanelIndex(5); // Bilge pump, index sensors 5
                    } else {
                        app.setSensorsPanelIndex(-1);
                        app.setSensorsPanelOpen(false);
                    }

                    if (to.params.id == "15") {
                        app.setControlPanelIndex(1); // Gas valve, index control 1
                        app.setControlPanelOpen(true);
                    } else if (to.params.id == "16") {
                        app.setControlPanelIndex(0); // Digital IO, index control 0
                        app.setControlPanelOpen(true);
                    } else {
                        app.setControlPanelIndex(-1);
                        app.setControlPanelOpen(false);
                    }
                } else {
                    app.setSensorsPanelIndex(-1);
                    app.setControlPanelIndex(-1);
                    app.setSensorsPanelOpen(false);
                    app.setControlPanelOpen(false);
                }
            }

            // if going from home
            if (to.name && from.name && from.name == "Home") {
                console.log("Going from home");
                if (to.name == "history") {
                    console.log("Going to history with params id: " + to.params.id);

                    if (to.params.id == "1") {
                        app.setHomePanelIndex(3); // Deck hatch, index home 3
                        app.setHomePanelOpen(true);
                    } else if (to.params.id == "2") {
                        app.setHomePanelIndex(0);  // Shore power, index home 0
                        app.setHomePanelOpen(true);
                    } else if (to.params.id == "3") {
                        app.setHomePanelIndex(1); // Smart plug, index home 1
                        app.setHomePanelOpen(true);
                    } else if (to.params.id == "10") {
                        app.setHomePanelIndex(2); // Main door, index home 2
                        app.setHomePanelOpen(true);
                    } else {
                        app.setHomePanelIndex(-1);
                        app.setHomePanelOpen(false);
                    }
                } else {
                    app.setHomePanelIndex(-1);
                    app.setHomePanelOpen(false);
                }
            }

            if (to.name && to.name !== "Logo") {
                const value = alarm.alarmStatus;
                if (value) {
                    const minutes = differenceInMinutes(new Date(), value.fetchAt);
                    if (minutes > 1440) {
                        next("/");
                    } else {
                        next();
                    }
                } else {
                    next("/");
                }
            } else {
                next();
            }
        }

        return;
    });


    idsrvAuth.useRouter(routerObj);

    return routerObj;
}

export default routerObj;
